/*eslint-disable */
import { bus } from '@/main';
export default {
  name: 'plan-status-popup',
  components: {},
  props: ['planID', 'planSTATUS'],
  data () {
    return {
      submitted:false
    }
  },
  computed: {
  },
  mounted () {
    console.log(this.planSTATUS, this.planID)
  },
  methods: {
    closePlanStatusChangePopup(){
      bus.$emit('planStatusChangeStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    confirmPlanStatusChangePopup(){
      this.submitted = true
      if(this.planSTATUS == 'ACTIVE'){
        let data = {
          billing_plan_id:this.planID
        }
        this.$store.dispatch('deactivatePlanFunc', data).then((res) => {
          toast.success('Subscription plan is deactivate successfully');
          this.submitted =  false
          this.$store.dispatch('getSubscriptionPlanListFunc');
          this.closePlanStatusChangePopup();
        })
      }else{
        let data = {
          billing_plan_id:this.planID
        }
        this.$store.dispatch('activatePlanFunc', data).then((res) => {
          toast.success('Subscription plan is activate successfully');
          this.submitted =  false
          this.$store.dispatch('getSubscriptionPlanListFunc');
          this.closePlanStatusChangePopup();
        })
      }
    }
  }
}